// components/WelcomeModal.tsx

import React, { useState } from 'react';
import config from '../config';

const STORAGE_KEY = 'fdb_welcome_dismissed';
const MESSAGE_TO_NEW_USERS = "Hello! Welcome to the demo of my personal financial dashboard project! All of the displayed information is mock data and can be added by you. Feel free to look around!";

export function shouldShowWelcome(): boolean {
    return localStorage.getItem(STORAGE_KEY) !== 'false';
}

interface WelcomeModalProps {
    onClose: () => void;
}

const TECH_STACK = [
    'React', 'TypeScript', 'Node.js', 'Python / Flask',  'PostgreSQL'
];

const TIPS: [string, string, string][] = [
    ["Keep track of each day's totals in the ", "Main page", "."],
    ["Add your accounts and totals in the ", "Accounts", " tab."],
    ["Add, browse, and filter transactions in the ", "Transactions", " tab."]
]

/* Function to display tips from a list. */
function displayTips(tips: [string, string, string][]) {
    return (tips.map(([begin, toBold, end]) => (
        <div className="wm-tip">
            <i className="ti ti-building-bank" aria-hidden="true" />
            <span>
                <li>
                    {begin}<b>{toBold}</b>{end}
                </li>
            </span>
          </div>
    )))
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ onClose }) => {
    const [showAgain, setShowAgain] = useState(true);

    const handleClose = () => {
        if (!showAgain){ localStorage.setItem(STORAGE_KEY, 'false');}
        onClose();
    };
    return (
    <div className="wm-overlay" aria-modal="true" role="dialog" aria-labelledby="wm-title">
      <div className="wm-modal">
 
        {/* Version badge */}
        <div className="wm-version-badge">
            {config.version}
        </div>
 
        <h2 id="wm-title" className="wm-title">{config.name} - Demo</h2>
 
        <p className="wm-body">{MESSAGE_TO_NEW_USERS}</p>
 
        {/* Quick start tips */}
        <div className="wm-tips">
            {displayTips(TIPS)}
        </div>
 
        {/* Tech stack pills */}
        <div className="wm-stack">
          {TECH_STACK.map((tech) => (
            <span key={tech} className="wm-stack-pill">{tech}</span>
          ))}
        </div>
 
        {/* Footer */}
        <div className="wm-footer">
          <label className="wm-dont-show">
            <input
              type="checkbox"
              checked={showAgain}
              onChange={(e) => setShowAgain(!e.target.checked)}
            />
            Don't show this again
          </label>
          <button className="ac-btn ac-btn-primary" onClick={handleClose}>
            Continue →
          </button>
        </div>
 
      </div>
    </div>
  );
};
 
export default WelcomeModal;